import { type ReactElement } from 'react'
import { isNotDefined, type RelevantGameData } from '@terros/common'
import { useNavigate } from '@tanstack/react-router'
import { getCompetitionWidgetState, useCompetitionWidgetGames } from '@front/model'
import { NotReady } from '@components'
import { CompetitionWidgetView } from './CompetitionWidgetView'

/** The viewer's own competitions, whatever the dashboard's range and filter say. */
export function CompetitionWidget(): ReactElement {
  const { data, isLoading, error } = useCompetitionWidgetGames()
  const navigate = useNavigate()

  if (isNotDefined(data)) return <NotReady inline error={error} id='Competitions' isLoading={isLoading} />

  const openCompetition = ({ game }: RelevantGameData): void => {
    navigate({ to: `/competition/${game.gameId}/${game.status === 'active' ? 'view' : 'summary'}` })
  }

  return (
    <CompetitionWidgetView
      games={data.games}
      now={Date.now()}
      state={getCompetitionWidgetState(data)}
      onCreate={() => navigate({ to: '/competition/add' })}
      onOpen={openCompetition}
    />
  )
}
